import { createActionGroup } from '@ngrx/store';

export const RecaptchaActions = createActionGroup({
  source: 'Recaptcha',
  events: {
    'Event Name': (payload: { key: string }) => ({ ...payload }),
  },
});
